import { Zahlungsart } from '@ps20/bff-models';
import { getZahlweiseFromText } from '@ps20-frontend/migrations';
import { StatePreV17, StateV17 } from './17_migrate_zahlung.interface';

export const migrateZahlung = (previousState: StatePreV17, newVersion: number): StateV17 => {
  return {
    ...previousState,
    version: newVersion,
    zahlung: {
      ...previousState.zahlung,
      zahlweise: previousState.zahlung.zahlweise
        ? getZahlweiseFromText(previousState.zahlung.zahlweise)
        : undefined,
      zahlungsart: previousState.zahlung.zahlungsart
        ? (Zahlungsart as Record<string, Zahlungsart>)[previousState.zahlung.zahlungsart.toUpperCase()]
        : undefined,
    },
  };
};
